<!--
 * @Author: your name
 * @Date: 2021-07-08 09:48:58
 * @LastEditTime: 2021-07-19 11:31:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\bannerUnit.vue
-->

<template>
  <div>
    <div class="channelData-hidden" v-if="channelData.isHidden">
      <el-divider>频道图</el-divider>
      <div class="open-btn">
        <eui-btn width="80" type="primary" @click.native.prevent="hiddenFloor"
          >显示</eui-btn
        >
      </div>
    </div>
    <div v-else>
      <div
        class="channel-content"
        v-if="channelData.channelList && channelData.channelList.length > 0"
      >
        <ul class="channel-box flex-sb">
          <li
            class="channel-item"
            v-for="(item, index) in channelData.channelList"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>
      <div class="channel-content" v-else>
        <ul class="channel-box flex-sb">
          <li
            class="channel-item"
            v-for="(item, index) in defaultChannelList"
            :key="index"
          >
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultData } from './data/defaultData';

export default {
  props: {
    activeName: {
      type: String,
      default: '',
    },
    channelData: {
      type: Object,
      default() {
        return {
          isHidden: false,
          channelList: [],
        };
      },
    },
  },
  mounted() {
    console.log(this.channelData, 12312312312);
  },
  data() {
    return {
      defaultChannelList: defaultData.channelList,
    };
  },
  methods: {
    hiddenFloor() {
      // eslint-disable-next-line vue/no-mutating-props
      this.channelData.isHidden = !this.channelData.isHidden;
      this.$parent.choosenComments('');
    },
  },
};
</script>

<style lang="scss" scoped>
.channel-box {
  height: 270px;
  .channel-item {
    cursor: pointer;
    img {
      height: 270px;
      width: 190px;
    }
  }
}
.channelData-hidden {
  width: 1200px;

  background: #f8f8f9;
  position: relative;
  .open-btn {
    position: absolute;
    top: -16px;
    right: 0;
  }
  p {
    width: 100%;
    height: 0;
    border-top: 1px solid #eee;
  }
}
</style>
